const CooperationList = () => import("@/vuepage/form-manage/cooperationList");
const DemoList = () => import("@/vuepage/form-manage/demoList");
const CustomizationList = () => import("@/vuepage/form-manage/customizationList");
const whitePaperList = () => import("@/vuepage/form-manage/whitePaperList");
export default [
  {
    path: "/cooperation-list",
    component: CooperationList,
    meta: [{ name: "表单管理" }, { name: "商务合作列表", activeRoute: "/cooperation-list" }],
  },

  {
    path: "/demo-list",
    component: DemoList,
    name: "/demo-list",
    meta: [{ name: "表单管理" }, { name: "预约演示列表", activeRoute: "/demo-list" }],
  },
  {
    path: "/customization-list",
    component: CustomizationList,
    name: "/customization-list",
    meta: [{ name: "表单管理" }, { name: "高端定制", activeRoute: "/customization-list" }],
  },
  {
    path: "/whitePaper-list",
    component: whitePaperList,
    name: "/whitePaper-list",
    meta: [{ name: "表单管理" }, { name: "白皮书下载", activeRoute: "/whitePaper-list" }],
  },
];
